// extracted by mini-css-extract-plugin
export var activeDot = "_2j-c";
export var buttonContainer = "_2j-9";
export var channelButton = "_2j-a";
export var clickable = "_2j-d";
export var content = "_2j-0";
export var contentFull = "_2j-2";
export var contentThird = "_2j-1";
export var contentWrapper = "_2j-7";
export var description = "_2j-5";
export var heightShort = "_2j-f";
export var image = "_2j-3";
export var imageContainer = "_2j-4";
export var selectButton = "_2j-e";
export var spinnerContainer = "_2j-b";
export var titleContent = "_2j-8";
export var titleWrapper = "_2j-6";